import React, { useState, useEffect } from "react";
import "./DataTable.scss";
import { CiSearch } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import Pagination from "../Pagination/Pagination";
import { PaginationData } from "../../../Redux/Reducers/Common/Pagination";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

const DataTable = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { data, columns } = props;

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending", 
  });
  const [searchQuery, setSearchQuery] = useState("");
  // const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(
    props.Dropdownvalues?.[0] || data?.length || 5
  );

  useEffect(() => {
    setCurrentPage(props.CCpage || 1);
  }, [data]);

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key !== null) {
      const keyA =
        typeof a[sortConfig.key] === "string"
          ? a[sortConfig.key].toUpperCase()
          : a[sortConfig.key];
      const keyB =
        typeof b[sortConfig.key] === "string"
          ? b[sortConfig.key].toUpperCase()
          : b[sortConfig.key];
      return sortConfig.direction === "ascending"
        ? keyA > keyB
          ? 1
          : -1
        : keyA < keyB
          ? 1
          : -1;
    }
    return 0;
  });

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const filteredData = sortedData.filter((row) =>
    columns.some((column) =>
      row[column.selector]
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    )
  );

  const toggleRowSelection = (rowId) => {
    if (props.PostSelectData.includes(rowId)) {
      props.GetSelectData(props.PostSelectData.filter((id) => id !== rowId));
    } else {
      props.GetSelectData([...props.PostSelectData, rowId]);
    }
  };
  const toggleAllRows = () => {
    if (props.PostSelectData.length === filteredData.length) {
      props.GetSelectData([]);
    } else {
      props.GetSelectData(filteredData);
    }
  };

  const handleRowsPerPageChange = (e) => {
    if (props.CountPage) {
      props.CountPage(e.target.value);
    }
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const requestSort = (key, sortable) => {
    if (!sortable) return;

    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  const LoadCurrentItems = (e) => {
    setCurrentPage(e);
    dispatch(
      PaginationData({
        Location: location.pathname,
        TableName: props.tablename || "",
        PageNumber: e,
      })
    );
    if (props.GetCurrentPage) {
      props.GetCurrentPage(e);
    }
    if (props.hitapi) {
      props.hitapi(e, rowsPerPage);
    }
  };
  return (
    <>
      <div className={props.className} style={{ maxWidth: props?.tableMinWidth || "100%", }} >
        <div className="Data-Table-Filters">
          <div className="SelectRows">
            {props.ShowPagecount && (
              <>
                Show:{" "}
                <select
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  className="Dropdown"
                >
                  {(props.Dropdownvalues || ["5", "10", "15"])?.map(
                    (item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    )
                  )}
                </select>
              </>
            )}
          </div>
         {!props.DisplaySearch &&  <div className="Search">
            {searchQuery.length === 0 && <CiSearch />}
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
              style={{ paddingLeft: searchQuery ? "20px" : "30px" }}
            />
            {searchQuery.length > 0 && (
              <IoMdClose
                onClick={() => {
                  setSearchQuery("");
                }}
              />
            )}
          </div>}
        </div>
        <div className="table-scroll">
          <table className="Data-Table mb-2">
            <thead>
              <tr>
                {props.showCheckboxes && (
                  <th>
                    <input
                      type="checkbox"
                      onChange={toggleAllRows}
                      checked={
                        props.PostSelectData?.length === filteredData?.length &&
                        filteredData.length > 0
                      }
                    />
                  </th>
                )}
                <th>S.No</th>
                {columns?.map((column, index) => (
                  <th
                    key={index}
                    onClick={() => requestSort(column.selector, column.sortable)}
                  >
                    {column.Hcell ? column.Hcell(column) : column.name}
                    {column.sortable &&
                      sortConfig.key === column.selector &&
                      (sortConfig.direction === "ascending" ? " 🔽" : " 🔼")}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData?.length > 0 ? (
                <>
                  {currentRows?.map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      style={
                        rowIndex === props.Selected
                          ? { backgroundColor: "#D3D3D3" }
                          : {}
                      }
                    >
                      {props.showCheckboxes && (
                        <td>
                          <input
                            type="checkbox"
                            checked={props.PostSelectData?.includes(row)}
                            onChange={() => toggleRowSelection(row)}
                          />
                        </td>
                      )}
                      <td>
                        {" "}
                        {props.NoPage !== "1"
                          ? (props.NoPage ? props.NoPage : currentPage) *
                          rowsPerPage -
                          rowsPerPage +
                          1 +
                          rowIndex
                          : rowIndex + 1}
                      </td>

                      {columns?.map((column, colIndex) => (
                        <td key={`${rowIndex}-${colIndex}`}>
                          {column.cell
                            ? column.cell(row, rowIndex)
                            : row[column.selector]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  {" "}
                  <td
                    colSpan={columns?.length + (props.showCheckboxes ? 2 : 1)}
                    style={{ textAlign: "center" }}
                  >
                    {" "}
                    *** No records Found ***{" "}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {props.ShowPagination && (
          <Pagination
            Recorsperpage={rowsPerPage}
            currentPage={
              data.length === currentRows?.length
                ? props.NoPage || 1
                : currentPage
            }
            totalPages={Math.ceil(
              (data.length === currentRows?.length
                ? props.TotalRecords || data.length
                : filteredData?.length) / rowsPerPage
            )}
            Totalrecords={
              data.length === currentRows?.length
                ? props.TotalRecords || data.length
                : filteredData?.length
            }
            onPageChange={(e) => {
              LoadCurrentItems(e);
            }}
          />
        )}
      </div>
    </>
  );
};
export default DataTable;